module.exports = __webpack_public_path__ + "img/level-excellent.762f1abc.png";